import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import OTPVerification from "../common/user-credentials/OtpVerification/OTPVerification";
import { hideOtpModal } from "@/redux/otpModal/otpModalSlice";
import { otpModalState } from "@/redux/otpModal/otpModalSelectors";

const GlobalOtpModal = () => {
  const isGlobalOtpModal = true;
  const otpState = useSelector(otpModalState);
  const dispatch = useDispatch();

  const handleClose = () => dispatch(hideOtpModal());

  return (
    <Modal
      show={otpState.showOtpModal}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="border-0 pb-2" />
      <Modal.Body className="p-4">
        <OTPVerification
          phoneNumber={otpState.otpPhoneNumber}
          isModal={true}
          onClose={handleClose}
          isFromGlobalOtpModal={isGlobalOtpModal}
          redirectScreen={otpState.redirectScreen}
          redirectionRequried={otpState.redirectionRequired}
        />
      </Modal.Body>
    </Modal>
  );
};

export default GlobalOtpModal;
